<div [formGroup]='parent' autocomplete="off" role="search" aria-describedby="search">
  <!-- <input type="text"
  (keyup)="searchTerm$.next($event.target.value)"> -->
  <label for="addressSearch" id="search" class="form-label">
    {{'Pension provider'}}
  </label>
  <input [formControlName]="controlName" class="form-control" style="margin-bottom: 10px;" id="addressSearch" name="addressSearch" [placeholder]="contentData['pensionProviderSearchplaceholder']"
    type="text" (keyup)="searchTerm$.next($event.target.value)"
    [value]="parent.get([controlName]).value"
    [(ngModel)]="controllerData.value"
    [required]="controllerData['required']" autocomplete="off" [maxlength]="controllerData['maxlength']">

    @if (suggestiontext) {
      <ul class="autofill" [ngClass]="{'hideList':!isListAddressEnabled}">
        @for (txt of suggestiontext; track txt; let i = $index) {
          <li [(value)]="suggestiontext[i]" (click)="onSelectProvider(txt)">
            {{txt}}
          </li>
        }
      </ul>
    }
    @if ( parent && parent.get('addressline1') && parent.get('addressline1').touched && parent.get('addressline1').errors) {
      <div class="form-validation-error clear-both">
        <i class="icon icon-error" aria-hidden="true"></i>
        <p [id]="'address-error'">
          please enter an address
        </p>
      </div>
    }

  </div>
  @if (parent.get([controlName]).touched && parent.get([controlName]).errors
    && controllerData['errorMessage']
    && controllerData['errorMessage'] !== '') {
    <div [id]="controlName+'-error'" class="form-validation-error error-wid"
      [ngClass]="{'width-100':(pageName === 'yourPensionSavings')}">
      <i class="icon icon-error" aria-hidden="true"></i>
      <!-- <p [id]="controlName+'-error-msg'" role="alert"
    aria-live="polite" aria-hidden="false">{{controllerData['errorMessage']}}</p> -->
    @if (parent.get(controlName).touched
      &&
      parent.get(controlName).hasError('required')) {
      <p
      [id]="controlName +'-error'">{{controllerData['errorMessage']}}</p>
    }
 <!-- <p *ngIf="parent.get(controlName).touched
       &&
    parent.get(controlName).errors.pattern" [id]="controlName +'-invalid-error'">
    {{controllerData['errorMessageInvalid']}}
  </p>
<p *ngIf="parent.get(controlName).touched
       &&
    parent.get(controlName).hasError('matchInvalid')" [id]="controlName +'-invalid-error'">
    {{controllerData['errorMatch']}}
  </p>  -->
  @if (parent.get(controlName).touched
    &&
    parent.get(controlName).hasError('notValidPensionProvider')) {
    <p [id]="controlName +'-invalidPensionProvider-error'">
      {{controllerData['invalidErrorMessage']}}
    </p>
  }
</div>
}